import { BaseFilterParameter, IBaseFilterParameter } from "../base-filter.parameter";
import { IBaseModel, BaseModel } from "../base.model";

export interface IDocumentListingViewmodel extends IBaseModel {

}
export class DocumentListingViewmodel extends BaseModel implements IDocumentListingViewmodel {

}


// WEBPACK FOOTER //
// ./src/models/documents/document-listing.viewmodel.ts